import api from 'Api';
import { endpoints } from '../../../api/dxApiEndpoints.js';
export class ApiService {
  async extractBusinessDetails(websiteUrl, facebookPageDetail, googlePlaceDetail, name, category, region, shortenFlow, queryParameters) {
    let postData = {
      websiteUrl,
      facebookPageDetail,
      googlePlaceDetail,
      name,
      category,
      region,
      shortenFlow,
      queryParameters
    };
    let response = await api.post('LocalBusiness/businessDetails', postData);
    return response.data.data;
  }
  async extractWebsiteScreenshot(website) {
    let response = await api.get('LocalBusiness/website/screenshot?website=' + website);
    return response.data.data;
  }
  async setOfferDetails(offerDetails){
    let response = await api.post('LocalBusiness/offerDetails', offerDetails);
    return response.data.data;
  }
  async customize(id, customizedProperties) {
    let response = await api.post(`/Template/${id}/customize`, customizedProperties);
    return response.data.data;
  }
  async uploadImage(imageData){
    let response = await api.post('/LocalBusiness/UploadImage', imageData);
    return response.data;
  }
  async updateAggregatedData(patch){
    await api.patch('LocalBusiness/businessDetails', patch);
  }
  async getBusinessDetailsBySessionId(sessionId) {
    let response = await api.get('LocalBusiness/businessDetails?sessionId=' + sessionId);
    return response.data.data;
  }

  async getCreativeConfig(data){
    await api.post('/LocalBusiness/CreativeConfiguration', data);
  }

  async getBusinessCategories(keyword) {
    let response = await api.get('LocalBusiness/BusinessCategories', {
      params: {
        keyword
      }
    });
    return response.data.data;
  }

  async getGeoLocation (name, countryCode, locationTypeId = 5) {
    let request = {
      name,
      locationTypeId
    };
    if (countryCode) {
      request.countryCode = countryCode;
    }
    let response = await api.get('LocalBusiness/geoLocation', {
      params: request
    });
    return response.data.data;
  }

  async creativeConfiguration(objectiveDetails){
    let response = await api.post('LocalBusiness/CreativeConfiguration', objectiveDetails);
    return response.data.data;
  }

  async signUp(singUpData) {
    let response = await api.post('LocalBusiness/signUp', singUpData);
    return response.data.data;
  }

  async getDefaultTargeting(){
    let response = await api.get('LocalBusiness/defaultTargeting');
    return response.data.data;
  }

  async getSearchLocation(keyword, types = '4,5,20', hasGoogleCode = true, countryCodes = '', limit = 20) {
    let response = await api.get(`Locations?keyword=${keyword}&types=${types}&hasGoogleCode=${hasGoogleCode}&countryCodes=${countryCodes}&limit=${limit}`);
    return response.data.data;
  }

  async getRoimaticCampaign(businessProfileId, campaignId) {
    let response = await api.get(`businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}`);
    return response.data.data;
  }

  async updateAdditionalConfiguration(businessProfileId, campaignId, data) {
    await api.patch(`businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}/additionalconfiguration`, data);
  }

  async generateEstimation(businessProfileId, campaignId, region) {
    let response = await api.post(`businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}/estimatebudget`, {
      region
    });
    return response.data.data;
  }

  async getCustomEstimation(businessProfileId, campaignId, amount) {
    let response = await api.get(`businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}/estimateConversion`, {
      params: {
        amount
      }
    });
    return response.data.data;
  }

  async getFacebookTargets(businessProfileId, campaignId, searchQuery = '') {
    let response = await api.get(`LocalBusiness/businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}/targets?searchQuery=${searchQuery}&fbTargetTypes=1&fbTargetTypes=3`);
    return response.data.targets;
  }

  async getGoogleKeywords(businessProfileId, campaignId) {
    let response = await api.get(`LocalBusiness/businessProfiles/${businessProfileId}/roimaticCampaigns/${campaignId}/keywords`);
    return response.data.keywords;
  }

  async sendEmailOtp(data) {
    let response = await api.post('LocalBusiness/sendOtp', data);
    return response.data.userAlreadyExist;
  }

  async sendSummaryLink(data) {
    let response = await api.post(endpoints.shareSummaryLink, data);
    return response.data;
  }

  async getSummaryId(data) {
    let response = await api.get(`${endpoints.getSessionIdById}?encodedId=${data}`);
    return response.data;
  }

  async getAggregatedbusinessDetails(sessionId) {
    let response = await api.get('LocalBusiness/businessDetails', {
      params: {
        sessionId
      }
    });
    return response.data.data;
  }

  async createDeltaXAccount(assetType, businessProfileId, deltaXPagePayload) {
    await api.post(
      `BusinessProfiles/${
        businessProfileId
      }/Roimatic/Assets`,
      {
        assetType: assetType,
        page: deltaXPagePayload
      }
    );
  }

  async requestAccess(businessProfileId, pageId, pageAccessToken) {
    let response = await api.post(
      `BusinessProfiles/${
        businessProfileId
      }/Roimatic/live/pageAccess`,
      {
        pageId: pageId,
        pageAccessToken: pageAccessToken
      }
    );

    return response != null && response.data ? response.data : null;
  }

  async assignSystemUserstoPage(businessProfileId, businessId, pageId) {
    let response = await api.post(
      `localbusiness/businessProfiles/${
        businessProfileId
      }/live/businesses/${
        businessId
      }/systemUserAccess`,
      {
        pageId: pageId
      }
    );

    return response != null && response.data ? response.data : null;
  }

  async assignPageAssets(businessProfileId, pageId, data) {
    return await api.post(`LocalBusiness/businessProfiles/${
      businessProfileId
    }/page/${pageId}/assignPageAssets`, data);
  }

  async updateFacebookPage(pageId, pageData) {
    let response = await api.put(
      `localbusiness/page/${
        pageId
      }`, pageData
    );

    return response != null && response.data ? response.data : null;
  }

  async getPageBackedInstagramAccount(pageId, data) {
    return await api.post(`localbusiness/page/${pageId}/pagebacked_instagram_accounts`, data);
  }

  async getInviteLink(userId, link, sendEmail) {
    let response = await api.post(`/users/${userId}/invite`, {
      link,
      sendEmail
    });
    return response.data.data;
  }

  async launchCampaign(payload) {
    let requestPayload = {
      isAsync: payload.isAsync ? payload.isAsync : true,
      microSiteRequest: payload.microSiteRequest,
      region: payload.region
    }
    let response = await api.post(`businessProfiles/${payload.businessProfileId}/roimaticCampaigns/${payload.campaignId}/launch`, requestPayload);
    return response.data.data;
  }

  async addPageToAssets(businessProfileId, businessProfileSearchEngineId, data) {
    return await api.post(`businessProfiles/${businessProfileId}/accounts/${businessProfileSearchEngineId}/accountAssets/pages`, data);
  }

  async addInstagramAccountToAssets(businessProfileId, businessProfileSearchEngineId, data) {
    return await api.post(`businessProfiles/${businessProfileId}/accounts/${businessProfileSearchEngineId}/accountAssets/instagramAccounts`, data);
  }

  async getAssignedPricingBandDetails(businessProfileId, isActive = false) {
    let response = await api.get(`businessprofiles/${businessProfileId}/assignedPricingBands`, {
      params: {
        isActive: isActive
      }
    });
    return response.data.data;
  }

  async getPricingBandLevel(currencyCode, promoCode) {
    let response = await api.get('pricingBandLevels', {
      params: {
        currencyCode: currencyCode,
        promoCode: promoCode
      }
    });
    return response.data.data;
  }

  async getUserSessionBusinessDetailsBySessionId(sessionId) {
    let response = await api.get(`/LocalBusiness/LocalBusinessUserSessions/${sessionId}`);
    return response.data.data;
  }

  async exchangeFbAccessToken(accessToken) {
    let response = await api.get('/Authentication/ExchangeFacebookAccessToken', {
      params: {
        exchangeToken: accessToken
      }
    });

    if (response && response.data && response.data.success) {
      return response.data.accessToken;
    }

    return null;
  }

  async createNewBusinessDetailsSession(businessProfileId) {
    let response = await api.post(`/BusinessProfiles/${businessProfileId}/LocalBusinessUserSessions`);
    return response.data.sessionId;
  }

  async createCampaigns(businessProfileId, campaign) {
    var response = await api.post(`/businessProfiles/${businessProfileId}/roimatic/campaigns`, campaign);
    return response.data.id;
  }

  async updateRoimaticCampaign(businessProfileId, roimaticCampaignId, sessionId){
    var response = await api.put(`businessProfiles/${businessProfileId}/roimaticcampaigns/${roimaticCampaignId}`, {
      sessionId
    });
    return response;
  }

  async getRoimaticCampaigns(businessProfileId, statuses) {
    var response = await api.get(`businessProfiles/${businessProfileId}/roimaticCampaigns`, {
      params: {
        statuses: statuses.join(',')
      }
    });
    return response.data.data;
  }

  async deleteDraftCampaign(businessProfileId, roimaticCampaignId, data) {
    var payload = JSON.stringify(JSON.stringify({ 'data': data }));
    await api.patch(`businessProfiles/${businessProfileId}/roimaticcampaigns/${roimaticCampaignId}`,
      payload, {
        headers: {
          'Content-type': 'application/json'
        }
      }
    );
  }

  async getBusinessImages(payload, businessProfileId = null) {
    if(businessProfileId){
      var response = await api.post('localBusiness/businessImages', payload, { params: { businessProfileId } });
    }
    else{
      var response = await api.post('localBusiness/businessImages', payload);
    }
    return response.data.data;
  }

  async updateCampaign(businessProfileId, campaignId, payload) {
    var response = await api.patch(`businessprofiles/${businessProfileId}/localBusiness/campaigns/${campaignId}`, payload);
    return response;
  }

  async getCampaignByMediaPlan(businessProfileId, mediaPlanIds) {
    let params = {
      mediaPlanIds: mediaPlanIds
    };
    var response = await api.get(`/businessProfiles/${businessProfileId}/roimatic/campaigns`, {
      params
    });
    return response.data.data;
  }

  async getUnsplashImages(payload) {
    var response = await api.get('roimatic/images/unsplash', {
      params: {
        keywords: payload.keywords,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize
      }
    });
    return response.data.data;
  }

  async getRoimaticImages(businessProfileId, payload) {
    var response = await api.get(`businessProfiles/${businessProfileId}/roimatic/images`, {
      params: {
        sortType: payload.sortType
      }
    });
    return response.data.data;
  }

  async addRoimaticImages(businessProfileId, payload) {
    var response = await api.post(`businessProfiles/${businessProfileId}/roimatic/images/url`, payload);
    return response.data.data;
  }

  async adAccountSetup(businessProfileId, payload){
    var response = await api.post(`localBusiness/businessProfiles/${businessProfileId}/adAccountsSetup`, payload);
    return response;
  }

  async validateOtp(validateOtpData) {
    let response = await api.post('LocalBusiness/validateOtp', validateOtpData);
    return response;
  }

  async getclient(businessProfileId, portalId){
    var response = await api.get(`/businessProfile/${businessProfileId}/portal/${portalId}/client`, {
      params: {
        businessProfileId: businessProfileId
      }
    });
    return response.data.data;
  }

  async generateEstimationBySession(sessionId, region) {
    let response = await api.post(`localBusiness/${sessionId}/estimatebudget`, {
      region
    });
    return response.data.data;
  }

  async getCustomEstimationBySession(sessionId, amount, region, portalDomain) {
    let response = await api.get(`localBusiness/${sessionId}/estimateConversion`, {
      params: {
        amount,
        region,
        portalDomain
      }
    });
    return response.data.data;
  }
  async updateclient(businessProfileId, portalId, clientdata){
    var response = await api.post(`/businessProfile/${businessProfileId}/portal/${portalId}/client/${clientdata.id}`, clientdata);
    return response;
  }

  async getAssignedPricingBandDetailsForSession(region, portalDomain) {
    let response = await api.get('localBusiness/pricingBand', {
      params: {
        region,
        portalDomain
      }
    });
    return response.data.data;
  }

  async getPricingBandLevelForSession(portalDomain, currencyCode, promoCode) {
    let response = await api.get('localBusiness/pricingBandLevels', {
      params: {
        portalDomain: portalDomain,
        currencyCode: currencyCode,
        promoCode: promoCode
      }
    });
    return response.data.data;
  }
}
